// This file configures the initialization of Sentry on the client.
// The added config here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/companions/:id\",\"regex\":\"^/companions/([^/]+)$\",\"paramNames\":[\"id\"]},{\"path\":\"/sign-in/:sign-in*?\",\"regex\":\"^/sign-in(?:/(.*))?$\",\"paramNames\":[\"sign-in\"]}],\"staticRoutes\":[{\"path\":\"/\"},{\"path\":\"/companions\"},{\"path\":\"/companions/new\"},{\"path\":\"/my-journey\"},{\"path\":\"/sentry-example-page\"},{\"path\":\"/subscription\"}]}";globalThis["_sentryNextJsVersion"] = "15.5.2";import * as Sentry from "@sentry/nextjs";

Sentry.init({
  dsn: "https://b6d27e5bcac21edfae03690a43c03578@o4509983138578432.ingest.us.sentry.io/4510001098588160",

  // Add optional integrations for additional features
  integrations: [
    Sentry.replayIntegration(),
  ],

  // Define how likely traces are sampled. Adjust this value in production, or use tracesSampler for greater control.
  tracesSampleRate: 1,
  // Enable logs to be sent to Sentry
  enableLogs: true,

  // Define how likely Replay events are sampled.
  // This sets the sample rate to be 10%. You may want this to be 100% while
  // in development and sample at a lower rate in production
  replaysSessionSampleRate: 0.1,

  // Define how likely Replay events are sampled when an error occurs.
  replaysOnErrorSampleRate: 1.0,

  // Setting this option to true will print useful information to the console while you're setting up Sentry.
  debug: false,
});

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;